import { useEffect, useState } from 'react';
import { postingLogApi } from '@/services/postingLogApi';
import type { PostingLogRow } from '@/utils/PostingLog/types';
import { mapPostingLogRow } from '@/utils/PostingLog/mappers';

export function usePostingLogLines(timesheetId: string | null, open: boolean, refreshKey: number) {
  const [lines, setLines] = useState<PostingLogRow[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!timesheetId || !open) return;
    let cancelled = false;
    setIsLoading(true);
    postingLogApi
      .getAllPostingLogRows({ timesheetId: Number(timesheetId), sortBy: 'transactionDate', sortDir: 'asc' })
      .then((items) => { if (!cancelled) setLines(items.map(mapPostingLogRow)); })
      .catch(() => { if (!cancelled) setLines([]); })
      .finally(() => { if (!cancelled) setIsLoading(false); });
    return () => { cancelled = true; };
  }, [timesheetId, open, refreshKey]);

  return { lines, isLoading };
}
